import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

export const fetchPakets = async (page = 1, per_page = 10, filters = {}) => {
  try {
    // Build query parameters
    const params = new URLSearchParams({
      page,
      per_page,
      // Use consistent keys as defined in your component's filter state
      ...(filters.kategori_paket && { kategori_paket: filters.kategori_paket }), // Corrected
      ...(filters.jenis_seleksi && { jenis_seleksi: filters.jenis_seleksi })
      // If you had a 'jenisPaket' filter in the component, it would be 'jenis_paket' here.
      // Since your component state uses 'kategori_paket', we use 'kategori_paket' here.
    });

    const response = await axios.get(`${BASE_URL_BE}/paket?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching paket:", error);
    throw error;
  }
};
export const createPakets = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}/paket`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating paket:", error);
    throw error;
  }
};

export const updatePakets = async (id_paket, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}/paket/${id_paket}`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating paket:", error);
    throw error;
  }
};

export const deletePakets = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}/paket/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting paket:", error);
    throw error;
  }
};

export const getSimulasiPaket = async (kategori_paket = '') => { // Tambahkan parameter kategori_paket dengan default value kosong
  try {
    const url = `${BASE_URL_BE}/list-tryouts`; // URL dasar API Anda

    
    const params = {
      page: 1,    
      per_page: 10, // Atur default per_page jika belum dihandle di komponen
    };

    // Tambahkan kategori_paket ke objek params hanya jika ada nilainya
    if (kategori_paket) {
      params.kategori_paket = kategori_paket;
    }

    // Lakukan permintaan GET menggunakan Axios.
    // Axios akan secara otomatis mengonversi objek 'params' menjadi query string di URL.
    // Contoh: .../list-tryouts?page=1&per_page=10&kategori_paket=TRYOUT
    const response = await axios.get(url, {
      headers: getAuthHeaders(),
      params: params, // Sertakan objek params di sini
    });

    return response.data;
  } catch (error) {
    console.error("Error get simulasi paket:", error);
    // Lebih baik lempar error agar bisa ditangani di komponen yang memanggilnya
    throw error;
  }
};

export const getPaketByID = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}/paket/${id}`, {
      headers: getAuthHeaders()
    });
    return response;
  } catch (error) {
    console.error("Error deleting paket:", error);
    throw error;
  }
};